import requestV2 from '../utils/requestV2';


// 标签接口类型定义
export interface Tag {
  id: string
  tag_name: string
  tag_code: string
  parent_id: string
  description: string
  materialCount: number
  create_time: string
  children: Tag[]
}

export interface TagQuery {
  page: number
  pageSize: number
  keyword?: string
}

export interface TagForm {
  tag_name: string
  tag_code: string
  parent_id: string
  description: string
}

// // 获取标签列表
// export const getTags = (params: TagQuery) => {
//   return request<{
//     data: Tag[]
//     total: number
//   }>({
//     url: '/system/tags',
//     method: 'GET',
//     params
//   })
// }
// 获取标签列表
export const getTags = (data: TagQuery) => {
  return requestV2.post('/system/tags/list', data);
}

// 创建标签
export const createTag = (data: TagForm) => {
  return requestV2<Tag>({
    url: '/system/tags',
    method: 'POST',
    data
  })
}

// 更新标签
export const updateTag = (id: string, data: Partial<TagForm>) => {
  return requestV2<Tag>({
    url: `/system/tags/${id}`,
    method: 'PUT',
    data
  })
}

// 删除标签
export const deleteTag = (id: string) => {
  return requestV2<{
    success: boolean
  }>({
    url: `/system/tags/${id}`,
    method: 'DELETE'
  })
}

// 获取所有标签(不分页)
export const getAllTags = () => {
  return requestV2<Tag[]>({
    url: '/system/tags/parent',
    method: 'GET'
  })
}